import { render } from "./voltageChart.vue?vue&type=template&id=98d19620&scoped=true"
import script from "./voltageChart.vue?vue&type=script&lang=js"
export * from "./voltageChart.vue?vue&type=script&lang=js"

import "./voltageChart.vue?vue&type=style&index=0&id=98d19620&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d19620"]])

export default __exports__